import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { Flex, Loading, Text } from "@paguelofacil/pf-components";

import { STEPS } from "../services/utils/Constants";
import { language, languageDefault } from "../services/utils/Language";
import { getSessionCryptofacil, getUserCryptofacil } from "../services/utils/StorageUtils";

import { HeaderPayment } from "../components/HeaderPayment";
import { ButtonBack } from "../components/ButtonBack";
import ValidateCode from "../components/ValidateCode";
import LoginForm from "../components/LoginForm";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/containers.scss";

const LoginCryptofacil = ({ intl }) => {
    const navigate = useNavigate();

    const [step, setStep] = useState(STEPS.LOGIN);
    const [isLoading, setIsLoading] = useState(false);
    const [valuesForm, setValuesForm] = useState({
        email: "",
        validationCode: "",
    });

    const handleChangeForm = (nameInput, value) => {
        setValuesForm({
            ...valuesForm,
            [nameInput]: value,
        });
    };

    useEffect(() => {
        const sessionCryptofacil = getSessionCryptofacil();
        const userCryptofacil = getUserCryptofacil();

        if (sessionCryptofacil && userCryptofacil) {
            return navigate("/cryptofacil/home");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AppWithErrorBoundary>
            <Loading isLoading={isLoading}>
                <Flex direction="column" width="auto" minW="auto" className="container-payment">
                    <HeaderPayment
                        title={
                            STEPS.CREATE_ACCOUNT === step ? (
                                <FormattedMessage
                                    id={language.title_login_cryptofacil}
                                    defaultMessage={languageDefault.title_login_cryptofacil}
                                />
                            ) : (
                                <FormattedMessage
                                    id={language.title_validation_code_login_cf}
                                    defaultMessage={languageDefault.title_validation_code_login_cf}
                                />
                            )
                        }
                    />
                    <Flex gap="0" wrap="nowrap">
                        <ButtonBack handleBack={() => navigate("/")} />
                        <Text variant="caption" weight="regular">
                            {STEPS.LOGIN === step ? (
                                <FormattedMessage
                                    id={language.subtitle_signup}
                                    defaultMessage={languageDefault.subtitle_signup}
                                />
                            ) : (
                                <>
                                    <FormattedMessage
                                        id={language.subtitle_validation_code_login_cf}
                                        defaultMessage={languageDefault.subtitle_validation_code_login_cf}
                                        values={{
                                            email: valuesForm.email,
                                        }}
                                    />
                                </>
                            )}
                        </Text>
                    </Flex>
                    {STEPS.LOGIN === step && (
                        <LoginForm
                            intl={intl}
                            handleChangeForm={handleChangeForm}
                            setIsLoading={setIsLoading}
                            valuesForm={valuesForm}
                            setStep={setStep}
                        />
                    )}
                    {STEPS.VALIDATE_CODE === step && (
                        <ValidateCode
                            intl={intl}
                            setIsLoading={setIsLoading}
                            handleChangeForm={handleChangeForm}
                            valuesForm={valuesForm}
                        />
                    )}
                </Flex>
            </Loading>
        </AppWithErrorBoundary>
    );
};

const LoginCryptofacilDecorate = injectIntl(LoginCryptofacil);

export default LoginCryptofacilDecorate;
